import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import BalanceListView from '../components/bill/balanceListView';
import * as BillAction from '../actions/billAction';
function mapStateToProps(state) {
  return {
    ...state.Bill,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...BillAction,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(BalanceListView);
